import { Component } from '@angular/core';
import {
  CcdlDividerComponent,
  CcdlLinkComponent,
} from '@cpm-pr1618001/ng-design-lib';

@Component({
  selector: 'privacy-and-policy',
  imports: [CcdlDividerComponent, CcdlLinkComponent],
  templateUrl: './privacy-and-policy.component.html',
  styleUrl: './privacy-and-policy.component.scss',
})
export class PrivacyAndPolicyComponent {}
